import { HUB_URL } from './constants.js'
import eventBus from './eventBus.js'

class SSEClient {
	constructor() {
		this.source = null
	}

	connect() {
		if (this.source) {
			return
		}

		const url = new URL(HUB_URL)
		url.searchParams.append('topic', '*')

		this.source = new EventSource(url)

		this.source.onopen = () => {
			console.log('SSE connected')
		}

		this.source.onerror = (err) => {
			console.error('SSE error', err)
		}

		this.source.onmessage = (event) => {
			try {
				const message = JSON.parse(event.data)

				// Expected format:
				// {
				//   topic: "...",
				//   payload: {...}
				// }

				eventBus.emit(message.topic, message.payload)
			} catch (err) {
				console.error('Invalid SSE message', err)
			}
		}
	}

	disconnect() {
		if (!this.source) {
			return
		}

		this.source.close()
		this.source = null
	}
}

export default SSEClient
